import {Interval} from "luxon";

import { FilterDef } from "@/stores/filters/FilterDef";
import { FilterParamValue } from "./FilterParamValue";

export class InsightsFilterDef extends FilterDef {

	static FILTER_DATERANGE = 'dateRange';
	static FILTER_PUPILIDS = 'pupilIds';

	constructor() {
		super([
			InsightsFilterDef.FILTER_DATERANGE,
			InsightsFilterDef.FILTER_PUPILIDS
		]);
	}

	set dateRange(interval: Interval | null) {
		if (interval) {
			this.setParamValue(InsightsFilterDef.FILTER_DATERANGE, interval.toISO());
		} else {
			this.clearParam(InsightsFilterDef.FILTER_DATERANGE);
		}
	}

	get dateRange(): Interval | null {
		const interval = this.getParamValues(InsightsFilterDef.FILTER_DATERANGE)[0]?.id;
		if (!interval) {
			return null;
		}
		return Interval.fromISO(interval as string);
	}

	transformApiParamValue(paramName: string, filterParamValue: FilterParamValue): { [key: string] : string | number } {
		const params: any = {};

		switch (paramName) {
			case InsightsFilterDef.FILTER_DATERANGE:
				const interval = Interval.fromISO(filterParamValue.id as string);
				if (!interval.isValid) {
					throw new Error('Invalid date range');
				}

				// Yea api only accepts ISO strings created by plain javascript, not luxon
				params['start'] = interval.start.toJSDate().toISOString();
				params['end'] = interval.end.toJSDate().toISOString();
				break;

			default:
				params[paramName] = filterParamValue.id;
				break;
		}

		return params;
	}
}
